'use client'
import { HStack as ChakraHStack } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { HStackProps } from './h-stack.types'

export default forwardRef(function HStack(
  props: HStackProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraHStack {...props} ref={ref} translate="no" />
})
